import owd from 'owd/owd';

export default class PortfolioFilter extends owd.Component {
	init() {
		this.$element = this.$element.parent().children($('.portfolio-filter'));
		this.$items = this.$element.find('.portfolio-filter-item:not(.dk-selected)');

		this.bind();
	}

	bind() {
		this.on('click', this.$items, (e) => {
			this.app.getModule('ajax').loadPage($(e.currentTarget).attr('data-value'), true, 'portfolio');
        });
	}

	destroy() {
		super.destroy();
	}
}

owd.registerComponent('portfolio-filter', {
	component: PortfolioFilter
});
